import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/constants/routes'
import { SEO } from '@/components/features/SEO'
import { Button } from '@/components/ui'
import styles from './NotFound.module.css'

export function NotFound() {
    const navigate = useNavigate()

    return (
        <div className={styles.container}>
            <SEO
                title="Pagina no encontrada - Peru IA"
                description="La pagina que buscas no existe."
                noindex
            />
            <div className={styles.content}>
                <h1>404</h1>
                <h2>Pagina no encontrada</h2>
                <p>La pagina que buscas no existe.</p>
                <Button
                    variant="primary"
                    onClick={() => navigate(ROUTES.home)}
                >
                    Volver al inicio
                </Button>
            </div>
        </div>
    )
}
